// export const ApiUrl = process.env.VUE_APP_PLANT_SERVER // 发布地址
export const ApiUrl = process.env.VUE_APP_PLANT_SERVER // 发布地址
export const eascUrl = process.env.VUE_APP_EASC_SERVER
export const { appId } = process.env

export const ERR_OK = true
/* eslint-disable */
export function getUrl(...query) {
  if (query.length === 1) {
    return query
  }
  // for (let i = 0; i < query.length; i++) {
  let result = []
  for (let j = 0; j < query.length; j++) {
    if (query[j] === '') {
      query[j] = ' '
    }
    result += query[j] + '/'
  }
  return result
  // }
}
/* eslint-enable */
export function exportExcelData(res, fileName) {
  const blob = new Blob([res.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const date = new Date()
  const year =
    date.getFullYear().toString().length >= 2
      ? date.getFullYear().toString()
      : `0${date.getFullYear().toString()}`
  const month =
    date.getMonth().toString().length >= 2
      ? (date.getMonth() + 1).toString()
      : `0${(date.getMonth() + 1).toString()}`
  const day =
    date.getDate().toString().length >= 2
      ? date.getDate().toString()
      : `0${date.getDate().toString()}`
  const hours =
    date.getHours().toString().length >= 2
      ? date.getHours().toString()
      : `0${date.getHours().toString()}`
  const minutes =
    date.getMinutes().toString().length >= 2
      ? date.getMinutes().toString()
      : `0${date.getMinutes().toString()}`
  const seconds =
    date.getSeconds().toString().lengtFh >= 2
      ? date.getSeconds().toString()
      : `0${date.getSeconds().toString()}`
  const milliseconds =
    date.getMilliseconds().toString().length >= 2
      ? date.getMilliseconds().toString()
      : `0${date.getMilliseconds().toString()}`
  // let fileName = res.header['content-disposition'].match(/fushun(\S*)xls/)[0]
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = fileName + year + month + day + hours + minutes + seconds + milliseconds
  link.click()
  window.URL.revokeObjectURL(link.href)
}
export const categoryId = '5baa612d-53ba-4674-9928-fa1301cfd086' // 位号类别Id
export const attributeId = '9832efb0-b0b1-4091-9310-2f937622db05' // 位号属性Id
export const tagId = 'f7f37c7d-a235-46a4-aad5-db53211a3014' // 位号对象Id1
export const numberId = 'a3da4291-4800-49a2-8707-60b297b53b45' // 文档管理Id
export const listId = 'a3da4291-4800-49a2-8707-60b297b53b45' // 文档清单Id
export const BreakdownId = '13eb3930-5d8e-4f2c-9f03-189031dc0def' // 目录结构配置树Id
export const tagObjectId = 'cc2127ee-c71b-4882-9787-fa4d31a676ca' // 位号对象浏览Id
export const documentId = '5342720c-ed31-4964-a457-82170d6076b3' // 文档对象管理Id
export const getId = '805ea8ae-c8cd-4cbd-a194-07edb335acb4' // 首页搜索Id
export const actionValueContents = {
  View: 1,
  Edit: 2,
  // 新增
  Add: 4,
  // 删除
  Delete: 8,
}
